<template>
    <base-heatmap id="received-heatmap" type="received" :color="blueColors" :required-metrics="requiredMetrics" :insight-text="insightText"></base-heatmap>
</template>

<script>
import ReportMetricMixin from '../mixins/report_metric_mixin';
import BaseHeatmap from './base_heatmap.vue';

export default {
    name: 'ReceivedHeatmap',
    components: {
        BaseHeatmap
    },
    mixins: [ReportMetricMixin],
    methods: {
        insightText(hour, weekday) {
            return `You usually receive more emails on ${weekday}s, at ${hour}.`;
        }
    }
};
</script>
